import { render, staticRenderFns } from "./DrawingHighlightList.vue?vue&type=template&id=0bfcf13e&scoped=true"
import script from "./DrawingHighlightList.vue?vue&type=script&lang=js"
export * from "./DrawingHighlightList.vue?vue&type=script&lang=js"
import style0 from "./DrawingHighlightList.vue?vue&type=style&index=0&id=0bfcf13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfcf13e",
  null
  
)

export default component.exports